import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=06013816&"
import script from "./confirmModal.vue?vue&type=script&lang=js&"
export * from "./confirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports